import { Injectable } from '@angular/core';
import { CMSLabelPostContainerModel } from '../../../models/cms/cms-label-post-container.model';
import { Core2Config } from '../../../utils/core2-config';
import { ApiVisa } from '../../../models/base/apivisa.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../../models/base/api-response.model';
import { HttpClient } from '@angular/common/http';
import { getHttpHeader } from '../../../utils/http-header.factory';
import { BaseService } from '../../../templates/services/base-service.template';

@Injectable({
  providedIn: 'root'
})
export class CMSLabelPostService implements BaseService {
    
  public readonly apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.UPSTATION_PREFIX + 'cms-category-posts';

  constructor(protected readonly http: HttpClient) {}

  public getLabelPost(parent_name: string, { tenantCode, api_domain_url, jwt_secret }: ApiVisa, country_code?: string): Observable<ApiResponseModel<CMSLabelPostContainerModel[]>>{
    let url: string = `${ api_domain_url }${ this.apiUrl }?parent_name=${ parent_name }`;
    if (country_code) url += `&country_code=${ country_code }`;

    return this.http.get<ApiResponseModel<CMSLabelPostContainerModel[]>>(url, getHttpHeader(jwt_secret, tenantCode));
  }
}
